
/* injects from baggage-loader */

'use strict';

import AccountAddNewBankAccountComponent from './account.add-new-bank-account.component';

const AccountAddNewBankAccountPageModule = angular.module('account-add-new-bank-account-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.add-new-bank-account', {
        url: '/add-new-bank-account',
        component: 'accountAddNewBankAccount',
        // Requires valid login to visit
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('accountAddNewBankAccount', new AccountAddNewBankAccountComponent());

export default AccountAddNewBankAccountPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/add-new-bank-account/account.add-new-bank-account.module.js